import { CookingRecipes } from '@teko/discovery';
import { LIMIT_ITEM_PER_PAGE_PRODUCT_LIST } from 'constants/index';
import { useProductDetailState } from 'contexts';
import { useSearch } from 'hooks';
import { useEffect, useMemo, useState } from 'react';

export const useProductRecipes = () => {
  const [selectedRecipe, setSelectedRecipe] = useState<CookingRecipes>();

  const { product: { cookingRecipes = [] } = {} } = useProductDetailState();

  const materialSkus = useMemo(() => {
    if (selectedRecipe) return selectedRecipe.ingredients?.map((item) => item);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRecipe?.url]);
  const {
    result: { products: materialProducts },
  } = useSearch(
    materialSkus?.length
      ? {
          page: 1,
          pageSize: LIMIT_ITEM_PER_PAGE_PRODUCT_LIST,
          filter: {
            skus: materialSkus,
          },
        }
      : {}, // empty object to skip request call API
  );

  useEffect(() => {
    if (
      !!cookingRecipes &&
      Array.isArray(cookingRecipes) &&
      !!cookingRecipes.length
    ) {
      setSelectedRecipe(cookingRecipes[0]);
    }
  }, [cookingRecipes]);

  const orderedMaterials = useMemo(() => {
    const selectedIngredients = selectedRecipe?.ingredients || [];

    if (!selectedIngredients.length) return undefined;
    return [...materialProducts].sort(
      (a, b) =>
        selectedIngredients.findIndex((i) => i === a.sku) -
        selectedIngredients.findIndex((i) => i === b.sku),
    );
  }, [selectedRecipe, materialProducts]);

  return {
    cookingRecipes,
    selectedRecipe,
    setSelectedRecipe,
    materialProducts,
    orderedMaterials,
  };
};
